import React from 'react';
import PropTypes from 'prop-types';
import { Box, TextField, Button } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  filtersContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    alignItems: 'center',
  },
  autocomplete: {
    width: 300,
  },
  autocompleteWide: {
    width: 400,
  },
}));

const DashboardFilters = ({ filters, onFilterChange, clients, files, isLoading }) => {
  const classes = useStyles();

  // The client list is ClientRecordSummary rows, which carry clientRecordId (the id Authorization.File.ClientId
  // references) and no clientId; filters.clientId holds that clientRecordId, as on the CSM and EA dashboards
  const handleClientChange = (event, newValue) => {
    onFilterChange({ clientId: newValue?.clientRecordId || null });
  };

  const handleFileChange = (event, newValue) => {
    onFilterChange({ fileId: newValue?.fileId || null });
  };

  const handleClearFilters = () => {
    onFilterChange({ clientId: null, fileId: null });
  };

  const selectedClient = clients.find(c => c.clientRecordId === filters.clientId) || null;
  const selectedFile = files.find(f => f.fileId === filters.fileId) || null;

  return (
    <Box className={classes.filtersContainer}>
      <Autocomplete
        className={classes.autocomplete}
        options={clients}
        getOptionLabel={(option) => option.shortName || ''}
        getOptionSelected={(option, value) => option.clientRecordId === value.clientRecordId}
        value={selectedClient}
        onChange={handleClientChange}
        disabled={isLoading}
        renderInput={(params) => (
          <TextField {...params} label="Client" variant="outlined" size="small" />
        )}
      />

      <Autocomplete
        className={classes.autocompleteWide}
        options={files}
        getOptionLabel={(option) =>
          (option.fileNumber && option.eeFullName
            ? `${option.fileNumber} - ${option.eeFullName}`
            : option.fileNumber || option.eeFullName || '')
          + (option.coveringForName ? ` (Covering for ${option.coveringForName})` : '')
        }
        value={selectedFile}
        onChange={handleFileChange}
        disabled={isLoading}
        renderInput={(params) => (
          <TextField {...params} label="Employee/File" variant="outlined" size="small" />
        )}
      />

      <Button onClick={handleClearFilters} disabled={isLoading}>
        Clear Filters
      </Button>
    </Box>
  );
};

DashboardFilters.propTypes = {
  filters: PropTypes.shape({
    clientId: PropTypes.number,
    fileId: PropTypes.number,
  }).isRequired,
  onFilterChange: PropTypes.func.isRequired,
  clients: PropTypes.arrayOf(PropTypes.shape({
    clientRecordId: PropTypes.number,
    shortName: PropTypes.string,
  })),
  files: PropTypes.arrayOf(PropTypes.shape({
    fileId: PropTypes.number,
    fileNumber: PropTypes.string,
    eeFullName: PropTypes.string,
    coveringForName: PropTypes.string,
  })),
  isLoading: PropTypes.bool,
};

DashboardFilters.defaultProps = {
  clients: [],
  files: [],
  isLoading: false,
};

export default DashboardFilters;
